<script setup lang="ts">
import { EMAIL_EDITABLE_KEY } from './composables/useEmailEditable'

const props = withDefaults(
  defineProps<{
    editable?: boolean
  }>(),
  {
    editable: false
  }
)

provide(EMAIL_EDITABLE_KEY, toRef(props, 'editable'))
</script>

<template>
  <slot />
</template>
